<template>
  <VPopup
    class="order-position-info-popup"
    :target="target"
    :visible="true"
    show-pointer
    align="left"
  >
    <dl>
      <dt>Описание:</dt>
      <dd>{{ position?.offer?.description || '--' }}</dd>

      <dt>Условия оплаты:</dt>
      <dd>
        <div v-for="paymentTerm in position?.requisites?.paymentTerms" :key="paymentTerm.stringRepresentation">
          {{ paymentTerm.stringRepresentation }}
        </div>
        <div v-if="!position?.requisites?.paymentTerms?.length">--</div>
      </dd>

      <dt>Расчётная дата оплаты:</dt>
      <dd>{{ $core.utils.date.format(position?.plannedPaymentDate) }}</dd>

      <dt>Производитель:</dt>
      <dd>{{ position?.manufacturer?.name || '--' }}</dd>

      <dt>Фасовка:</dt>
      <dd>{{ position?.packageVolume?.format(position?.unit) || '--' }}</dd>
    </dl>
  </VPopup>
</template>

<style lang="scss" src="./OrderPositionInfoPopup.scss" />

<script lang="ts">
import type OrderPosition from '@/domains/Orders/OrderPosition';

export default defineComponent({
  name: 'OrderPositionInfoPopup',

  props: {
    position: {
      type: Object as PropType<OrderPosition>,
      default: null,
    },
    target: {
      type: HTMLElement,
      default: null,
    },
  },
});
</script>
